<div>
  <div
    class="search-menu-input"
    [ngClass]="variant"
    [style]="{ 'max-width': maxWidth }"
  >
    <input
      [(ngModel)]="textValue"
      (ngModelChange)="onInputChange($event)"
      (keyup.enter)="onSearchIconClick()"
      type="text"
      [placeholder]="placeholder"
    />
    <img
      [src]="
        variant == 'second'
          ? 'assets/img/icons/search-transparent.svg'
          : 'assets/img/icons/search.svg'
      "
      alt="search-icon"
      height="50"
      width="50"
      (click)="onSearchIconClick()"
    />
  </div>

  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>
</div>
